/**
 * Created by emanuele on 31/01/2017.
 */
import React from 'react';

const ShowTipoSoggettoCompact = ({ soggetto, extraClassName }) => {

    if (soggetto !== null && soggetto !== undefined && (soggetto.isProspect || soggetto.isCliente || soggetto.isFornitore || soggetto.isTp))
    {
        let rv1 = null;
        let rv2 = null;
        let rv3 = null;
        let rv4 = null;
        if (soggetto.isProspect)
        {
            rv4 = <span className={extraClassName}>P</span>
        }
        if (soggetto.isCliente)
        {
            rv1 = <span className={extraClassName}>C</span>
        }
        if (soggetto.isFornitore)
        {
            rv2 = <span className={extraClassName}>F</span>
        }
        if (soggetto.isTp)
        {
            rv3 = <span className={extraClassName}>T</span>
        }
        return <span>{rv4}{rv1}{rv2}{rv3}</span>;
    }
    else{
        return null
    }
}

export default ShowTipoSoggettoCompact;


/** WEBPACK FOOTER **
 ** ./src/components/rubrica/ShowTipoSoggettoCompact.jsx
 **/